module.exports = __webpack_public_path__ + "static/media/AC.b23a307f.png";